import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError, change } from 'redux-form'

import {
    REQUEST_PROMOTIONS,
    FETCH_PROMOTIONS_SUCCESS,
    FETCH_PROMOTIONS_FAILURE,
    SELECT_PROMOTIONS,
    RESET_CURRENT_PROMOTIONS,
    REQUEST_PROMOTIONS_DETAIL,
    FETCH_PROMOTIONS_DETAIL_SUCCESS,
    FETCH_PROMOTIONS_DETAIL_FAILURE,
    REQUEST_ADDING_PROMOTION,
    ADD_PROMOTION_SUCCESS,
    ADD_PROMOTION_FAILURE,
    REQUEST_DELETE_PROMOTION,
    DELETE_PROMOTION_SUCCESS,
    DELETE_PROMOTION_FAILURE,
    REQUEST_EDITING_PROMOTION,
    EDIT_PROMOTION_SUCCESS,
    EDIT_PROMOTION_FAILURE,
    REQUEST_SAVE_PROMOTION,
    SAVE_PROMOTION_SUCCESS,
    SAVE_PROMOTION_FAILURE,
    REQUEST_SAVE_PROMO_NOTES,
    SAVE_PROMO_NOTES_SUCCESS,
    SAVE_PROMO_NOTES_FAILURE,
    REQUEST_PROMO_NOTES,
    FETCH_PROMO_NOTES_SUCCESS,
    FETCH_PROMO_NOTES_FAILURE,
    SET_CURRENT_PROMO,
    RESET_CURRENT_PROMO,
    REQUEST_PROMO_DETAILS,
    FETCH_PROMO_DETAILS_SUCCESS,
    FETCH_PROMO_DETAILS_FAILURE,
    CLEAR_PROMO_DETAIL_STATUS,
} from '../actions/type'

import {
    PROMOTIONS_URL,
    PROMO_NOTES_URL,
    GROUPS_URL,
} from './url';

import { DEFAULT_ERROR } from '../components/Common/constants';
// Inventories Actions

export function fetchPromotions(handleSuccess, handleFailure) {
  return axios({
    method: 'get',
    url: PROMOTIONS_URL,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then((response) => {
      handleSuccess(response);
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      handleFailure(err.data);
    });
}

export function selectPromotions(promotions) {
    return {
        type: SELECT_PROMOTIONS,
        payload: promotions
    };
}

export function resetCurrentPromotions() {
    return {
        type: RESET_CURRENT_PROMOTIONS
    }
}


export function fetchPromotionsDetail(promotions_id) {
    return dispatch => {
        dispatch({ type: REQUEST_PROMOTIONS_DETAIL });
        return axios.get(PROMOTIONS_URL + promotions_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchPromotionsDetailSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(fetchPromotionsDetailFailure(err));
            });
    }
}

export function fetchPromotionsDetailSuccess(promotionsDetail) {
    promotionsDetail = promotionsDetail.data;
    if(promotionsDetail.EndDate) promotionsDetail.EndDate = new Date(promotionsDetail.EndDate);
    if(promotionsDetail.StartDate) promotionsDetail.StartDate = new Date(promotionsDetail.StartDate);
    console.log("2", promotionsDetail);
    return {
        type: FETCH_PROMOTIONS_DETAIL_SUCCESS,
        payload: promotionsDetail
    };
}

export function fetchPromotionsDetailFailure(error) {
    return {
        type: FETCH_PROMOTIONS_DETAIL_FAILURE,
        payload: error
    };
}

export function addNewPromotion({
    Name,
    Type,
    Product,
    Qualification,
    Discount,
    StartDate,
    EndDate
}, CustomersFull) {
  let Customers = [];
  CustomersFull.map(customer => {
    Customers.push(customer.Customer_id);
  })
  Product = Product.value;
  return dispatch => {
      dispatch({ type: REQUEST_ADDING_PROMOTION });
      axios.post(PROMOTIONS_URL,
          {
            Name,
            Type,
            Product,
            Qualification,
            Discount,
            StartDate,
            EndDate,
            Customers
          },
          {
              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          }
      )
          .then(response => {
            dispatch(addPromotionSuccess());
          }, err => {
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            dispatch(addPromotionFailure(err));
          });
  }
}

export function addPromotionSuccess() {
    return {
      type: ADD_PROMOTION_SUCCESS,
    }
}

export function addPromotionFailure(response) {
    return {
      type: ADD_PROMOTION_FAILURE,
      payload: response
    }
}

export function saveEdittedPromotion(promotionId, promotionLine, handleSuccess, handleFailure) {
  return axios({
    method: 'put',
    url: `${PROMOTIONS_URL}${promotionId}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    data: promotionLine,
  })
    .then((response) => {
      handleSuccess(response);
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      handleFailure(err.data);
    });
}

export function deletePromotion(promotionId, handleSuccess, handleFailure) {
  axios({
    method: 'delete',
    url: `${PROMOTIONS_URL}${promotionId}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then((response) => {
      handleSuccess(response);
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      handleFailure(err.data);
    });
}

export function setPromoRowValue(title, form) {
  return dispatch => {
    dispatch(change(form, 'ProductInformation' , title));
  }
}

export function setField(field, value) {
  console.log("setting field", field, value)
  return dispatch => {
    dispatch(change('promotions', field , value));
  }
}

export function savePromotion(promotionLine, handleSuccess, handleFailure) {
  return axios({
    method: 'post',
    url: `${PROMOTIONS_URL}`,
    data: promotionLine,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then((response) => {
    handleSuccess(response);
  }, (err) => {
    if (err.status === 500 || err.status === 404) {
      err.data = DEFAULT_ERROR;
    }
    handleFailure(err.data);
  });
}

export function savePromoNotes({
  PromotionsNote,
  SalesNote
}) {
  return dispatch => {
      dispatch({ type: REQUEST_SAVE_PROMO_NOTES });
    axios.put(PROMO_NOTES_URL,
          {
            PromotionsNote,
            SalesNote
          },
          {
              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          }
      )
          .then(response => {
              dispatch(savePromoNotesSuccess());
          }, err => {
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            dispatch(savePromoNotesFailure(err));
          });
  }
}

export function savePromoNotesSuccess() {
  return {
    type: SAVE_PROMO_NOTES_SUCCESS
  }
}

export function savePromoNotesFailure(error) {
  return {
    type: SAVE_PROMO_NOTES_FAILURE,
    payload: error
  }
}

export function fetchPromoNotes() {
  return dispatch => {
      dispatch({ type: REQUEST_PROMO_NOTES });
    axios.get(PROMO_NOTES_URL,
          {
              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          }
      )
          .then(response => {
              dispatch(fetchPromoNotesSuccess(response));
          }, err => {
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            dispatch(fetchPromoNotesFailure(err));
          });
  }
}

export function fetchPromoNotesSuccess(notes) {
  return {
    type: FETCH_PROMO_NOTES_SUCCESS,
    payload: notes
  }
}

export function fetchPromoNotesFailure(error) {
  return {
    type: FETCH_PROMO_NOTES_FAILURE,
    payload: error
  }
}

export function setCurrentPromo(Product_id) {
  return {
    type: SET_CURRENT_PROMO,
    payload: Product_id,
  }
}

export function resetCurrentPromo() {
  return {
    type: RESET_CURRENT_PROMO
  }
}

export function fetchPromoDetails(promotionLineId, handleSuccess, handleFailure) {
  return axios({
    method: 'get',
    url: `${PROMOTIONS_URL}${promotionLineId}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then((response) => {
      handleSuccess(response);
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      handleFailure(err.data);
    });
}

export function fetchPromoDetailsByProduct(productId, handleSuccess, handleFailure) {
  return axios({
    method: 'get',
    url: `${PROMOTIONS_URL}`,
    params: {
      Product_id: productId,
    },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then((response) => {
      handleSuccess(response);
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      handleFailure(err.data);
    });
}

export function clearPromoDetailStatus() {
  return {
    type: CLEAR_PROMO_DETAIL_STATUS
  }
}

export function fetchGroups(handleSuccess, handleFailure) {
  return axios({
    method: 'get',
    url: GROUPS_URL,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then((response) => {
      handleSuccess(response.data);
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      handleFailure(err.data);
    });
}

export function fetchGroupCategories(group_id, handleSuccess, handleFailure) {
  return axios({
    method: 'get',
    url: `${GROUPS_URL}categories/${group_id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then((response) => {
      handleSuccess(response.data);
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      handleFailure(err.data);
    });
}



// WEBPACK FOOTER //
// ./master/jsx/actions/promotions_actions.jsx